var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pt-5" }, [
    _c(
      "div",
      { staticClass: "w-mobile mx-auto px-3" },
      [
        _c("div", { staticClass: "text-center w-100 mb-3" }, [
          _c("img", {
            staticClass: "mr-2",
            attrs: {
              src: "/images/stan-logo-text.svg",
              width: "107px",
              height: "37px",
              alt: "logo"
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text-large mt-2" }, [
            _vm._v(_vm._s(_vm.$t("Get your bag 💰💸😤")))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("MFAValidation", {
              attrs: {
                configName: _vm.mfaConfigName,
                nextRoute: _vm.mfaLoginEndpoint,
                token: _vm.mfaToken
              },
              on: { close: () => (_vm.submittingForm = false) }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex justify-content-center mt-5 pt-3 mb-5" },
          [
            _c(
              "form",
              {
                staticClass: "validate-form w-100",
                attrs: { id: "login" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.loginUser.apply(null, arguments)
                  },
                  keydown: function($event) {
                    return _vm.form.onKeydown($event)
                  }
                }
              },
              [
                _c("AppInput", {
                  staticClass: "form-group",
                  attrs: {
                    error:
                      _vm.ajax_error.errors &&
                      _vm.ajax_error.errors.email_or_username
                        ? _vm.ajax_error.errors.email_or_username
                        : [],
                    icon: _vm.emailOrUsernameImage,
                    type: "text",
                    placeholder: "Email or Username",
                    "data-test-id": "login-input"
                  },
                  model: {
                    value: _vm.form.email_or_username,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "email_or_username", $$v)
                    },
                    expression: "form.email_or_username"
                  }
                }),
                _vm._v(" "),
                _c("AppInput", {
                  staticClass: "form-group",
                  attrs: {
                    error: _vm.ajax_error.errors.password,
                    icon: "/images/icons/ic-lock.svg",
                    placeholder: _vm.$t("Password"),
                    type: "password",
                    "data-test-id": "password-input"
                  },
                  model: {
                    value: _vm.form.password,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "password", $$v)
                    },
                    expression: "form.password"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group mb-0" },
                  [
                    _c(
                      "AppButton",
                      {
                        staticClass: "w-100",
                        attrs: {
                          name: "login-submit-button",
                          fullwidth: "",
                          size: "large",
                          disabled: _vm.submittingForm,
                          loading: _vm.submittingForm,
                          "data-test-id": "submit-button"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Sign In")))]
                    ),
                    _vm._v(" "),
                    _vm.ajax_error &&
                    _vm.ajax_error.message &&
                    _vm.ajax_error.errors.length === 0
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "error-message stan-text-danger f-14 pt-2"
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.ajax_error.message) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "RouterLink",
                      {
                        staticClass: "d-block w-100 text-center mt-2",
                        attrs: { to: { name: "forgot_password" } }
                      },
                      [_vm._v(_vm._s(_vm.$t("Forgot password?")))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "text-center" },
          [
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.$t("Don't have an account?")) + "\n\t\t\t"
            ),
            _c(
              "RouterLink",
              {
                staticClass: "underline-text text-bold",
                attrs: {
                  to: {
                    name: "register"
                  },
                  "data-test-id": "register-link"
                }
              },
              [_vm._v(_vm._s(_vm.$t("Register")) + "\n\t\t\t")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.hasExistingAccount
          ? [
              _c("hr"),
              _vm._v(" "),
              _c("p", { staticClass: "text-center" }, [
                _c(
                  "a",
                  {
                    staticClass: "text-bold underline-text",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.backToLoggedInAccount.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("Go back to dashboard")]
                )
              ])
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }